var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app-settings" } }, [
    _c("div", { staticClass: "wrap", class: { buffering: _vm.getBuffering } }, [
      _c("button", {
        staticClass: "player",
        class: _vm.getPlaying ? "pause" : "play",
        on: { click: _vm.togglePlay }
      })
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "volumeIcon",
      class: _vm.getVolume == 0 ? "volumeMute" : "volumeFull",
      on: { click: _vm.toggleMute }
    }),
    _vm._v(" "),
    _c("input", {
      staticClass: "volume",
      attrs: { type: "range", name: "volume", min: "0", max: "1", step: ".05" },
      domProps: { value: _vm.getVolume },
      on: {
        input: function($event) {
          return _vm.setVolume($event.target.value)
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "playerMetadata" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.getTitle) + "\n\t")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }